
import { defineComponent } from "vue";
import { insuranceStore } from "@/stores/InsuranceStore";
import { mapState } from "pinia";

export default defineComponent({
  name: "SummaryConsents",
  computed: {
    ...mapState(insuranceStore, ["policyInfo"]),
  },
});
